var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('supplierdeductionadjust-check',{attrs:{"sna-id":_vm.snaId,"pagetitle":"供应商抵扣金额调整审批详情"}})}
var staticRenderFns = []

export { render, staticRenderFns }